import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4 mt-0">
      <div className="container">
        <div className="row text-center text-md-start align-items-start">
          <div className="col-md-4 mb-4 mb-md-0">
            <h5 className="fw-bold"> Rechtsanwaltskanzlei Sergej Vorrat </h5>
            <p className="mb-1">Kobergerplatz 13</p>
            <p className="mb-0">90408 Nürnberg</p>
          </div>

          <div className="col-md-4 mb-4 mb-md-0">
            <h5 className="fw-bold">Kontakt</h5>
            <p className="mb-1">
              
              <a
                href="tel:+491577 3430153"
                className="text-white text-decoration-none"
              >
                01577 3430153
              </a>
            </p>
            <p className="mb-0">
              
              <a
                href="mailto:kanzlei@ravorrat.de"
                className="text-white text-decoration-none"
              >
                kanzlei@ravorrat.de
              </a>
            </p>
          </div>

          <div className="col-md-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start text-center text-md-start">
              <div className="mb-3 mb-md-0">
                <h5 className="fw-bold">Rechtliches</h5>
                <ul className="list-unstyled mb-0">
                  <li>
                    <Link to="/legal" className="text-white text-decoration-none">
                      Impressum
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy" className="text-white text-decoration-none">
                      Datenschutz
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="mt-3 mt-md-0 d-none d-md-block">
                <img src={logo} alt="Helles Logo" className="footer-logo" />
              </div>
            </div>
          </div>
        </div>

        <hr className="border-light my-3" />

        <div className="text-center small">
          &copy; 2025 Sergej Vorrat – Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default Footer;